import * as actionTypes from 'actions';

const initialState = {
    Loading: false,
    scoringList: [],
    scoringRecord: [],
    scoringDropdownList: [],
    validation_error: "",
    redirect_to_list: false,
    showDeleteModel: false,
    showUpdateForm: false,
    showViewPage: false,
}

const ScoringReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SCORING_REQUEST:
            return {
                ...state,
                Loading: true,
                validation_error: "",
                redirect_to_list: false,
            }
        case actionTypes.SCORING_SERVER_SUCCESS:
            return {
                ...state,
                Loading: false,
                redirect_to_list: false,
                validation_error: "",
                showUpdateForm: false,
                showViewPage: false,
                scoringRecord: [],
            } 
        case actionTypes.SCORING_DROPDOWN_SUCCESS:
            return {
                ...state, 
                Loading: false,
                scoringDropdownList: action.scoringDropdownList,
            }
        case actionTypes.SCORING_SUCCESS:
            return {
                ...state,
                Loading: false,
                redirect_to_list: false,
                validation_error: "",
                scoringList: action.scoringList,
                showUpdateForm: false,
                showViewPage: false,
                scoringRecord: [],
            }
        case actionTypes.SCORING_GET_SUCCESS:
            return {
                ...state,
                Loading: false,
                redirect_to_list: false,
                scoringRecord: action.record,
                showUpdateForm: (action.actionType === 'update') ? true : false,
                showViewPage: (action.actionType === 'view') ? true : false
            }
        case actionTypes.SCORING_VALIDATION_ERROR:
            return {
                ...state,
                Loading: false,
                redirect_to_list: false,
                validation_error: action.validation_error,
            }
        case actionTypes.HIDE_SCORING_FEILD_VALIDATION_ERROR:
            if (state.validation_error && state.validation_error[action.feild_key])
                delete state.validation_error[action.feild_key]
            return {
                ...state,
                Loading: false,
                redirect_to_list: false,
                validation_error: action.validation_error,

            }
        case actionTypes.REDIRECT_TO_SCORING_LIST:
            return {
                ...state,
                redirect_to_list: true,
                showUpdateForm: false,
                showViewPage: false,
                validation_error: '',
                scoringRecord: [],
            }
        default:
            return state;
    }
}

export default ScoringReducer;